"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThorchainSwapper = void 0;
const types_1 = require("@shapeshiftoss/types");
class ThorchainSwapper {
    getType() {
        return types_1.SwapperType.Thorchain;
    }
    getUsdRate(input) {
        console.info(input);
        throw new Error('ThorchainSwapper: getUsdRate unimplemented');
    }
    getMinMax(input) {
        console.info(input);
        throw new Error('ThorchainSwapper: getMinMax unimplemented');
    }
    async approvalNeeded() {
        throw new Error('ThorchainSwapper: approvalNeeded unimplemented');
    }
    async approveInfinite() {
        throw new Error('ThorchainSwapper: approveInfinite unimplemented');
    }
    filterBuyAssetsBySellAssetId() {
        return [];
    }
    filterAssetIdsBySellable() {
        return [];
    }
    async buildTrade() {
        throw new Error('ThorchainSwapper: buildTrade unimplemented');
    }
    async getTradeQuote() {
        throw new Error('ThorchainSwapper: getTradeQuote unimplemented');
    }
    async executeTrade() {
        throw new Error('ThorchainSwapper: executeTrade unimplemented');
    }
}
exports.ThorchainSwapper = ThorchainSwapper;
